import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';

import {ROUTES} from '../config';

const imgTitle = new URL(
	'../../img/intro-title.png',
	import.meta.url
).toString();
const imgClaim = new URL(
	'../../img/intro-claim.png',
	import.meta.url
).toString();
const imgQuote = new URL(
	'../../img/intro-quote.png',
	import.meta.url
).toString();

export default function Intro() {
	const [claimImageOffset, setClaimImageOffset] = useState(0);
	const claimImageElementRef =
		/** @type {React.MutableRefObject<HTMLImageElement |null>} */ (
			useRef(null)
		);

	const updateOffset = useCallback(() => {
		const claimImageElement = claimImageElementRef.current;
		if (claimImageElement) {
			const newOffset = -Math.round(0.4 * claimImageElement.offsetHeight);
			setClaimImageOffset(newOffset);
		}
	}, []);

	useEffect(() => {
		window.addEventListener('resize', updateOffset);
		updateOffset();

		return () => {
			window.removeEventListener('resize', updateOffset);
		};
	}, [updateOffset]);

	return (
		<div className="bsknacht17-intro__wrapper">
			<div className="bsknacht17-intro bsknacht17-intro--title">
				<div className="bsknacht17-intro__image-wrapper">
					<img
						className="bsknacht17-intro__image"
						alt="13. Braunschweig Kulturnacht, Samstag, 22. Juni ab 18 Uhr"
						src={imgTitle}
					/>
				</div>
			</div>

			<div className="bsknacht17-intro bsknacht17-intro--claim">
				<div className="bsknacht17-intro__image-wrapper">
					<img
						className="bsknacht17-intro__image"
						ref={claimImageElementRef}
						onLoad={updateOffset}
						style={{
							marginTop: claimImageOffset,
							marginBottom: '-7%',
						}}
						alt="Die Nacht mit dem Pin"
						src={imgClaim}
					/>
				</div>

				<Link
					className="bsknacht17-intro__button"
					to={ROUTES.LIST.path}
				>
					zum Programm
				</Link>
			</div>

			{/* <div className="bsknacht17-intro bsknacht17-intro--call2action">
				<img
					className="bsknacht17-intro__quote"
					alt="Kultur ist da wo du bist!"
					src={imgQuote}
				/>
			</div> */}
		</div>
	);
}
